import { useFetchFromHarvestApp as fetch } from './useApi'

export default function () {
  const { result, error, loading } = fetch('/platform/running_time_entry')

  let timeEntry = undefined

  if (result) {
    timeEntry = result
  }

  return { timeEntry, error, loading }
}
